<template>
  <Modal
    title="Select Task"
    class-name="task-picker-modal"
    no-submit
    @hide-modal="$emit('hide-modal')"
    @show-modal="modalVisible = true"
  >
    <div>
      <TextField
        v-model="searchField"
        class="search-task-box mb-3 full-width"
        type="search"
        :placeholder="searchPlaceHolder"
      />
    </div>
    <Transition>
      <TaskPicker
        v-if="modalVisible"
        :tree="tasksTree"
        :search="searchField"
        class="picker"
        :show-upgrades="false"
        :show-addons="false"
        :show-prices="false"
        @item-filter="itemFilter"
        @add-task="handleAddTask"
        @category-change="handleCategoryChange"
        @search-cleared="handleSearchCleared"
      />
    </Transition>
    <template #submit>
      <div></div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import Transition from "@/components/Transition.vue";

export default {
  components: {
    Modal,
    TextField,
    Transition
  },
  props: {},
  emits: ["add-task", "hide-modal"],
  data() {
    return {
      searchField: "",
      searchPlaceHolder: "Search All Tasks",
      modalVisible: false
    };
  },
  computed: {
    ...mapState(["tasksTree"])
  },
  mounted() {
    this.fetchTasksTree();
  },
  methods: {
    ...mapActions(["fetchTasksTree"]),
    itemFilter(item, itemParent) {
      return item.kind !== "category" || itemParent;
    },
    handleAddTask(allItems, task, addons, doneCallback) {
      this.$emit("add-task", task);
      if (doneCallback) {
        doneCallback();
      }
    },
    handleCategoryChange(category) {
      this.searchPlaceHolder = `Search ${category.name || "All"} Tasks`;
    },
    handleSearchCleared() {
      this.searchField = "";
    }
  }
};
</script>

<style lang="scss">
.search-task-box {
  margin-bottom: 0px;
  width: 100%;
}
.picker {
  height: calc(100% - 50px) !important;
  font-size: 1rem;
}
.task-picker-modal {
  .modal-body {
    height: 80vh;
    .col-md-12.parsley-validations {
      height: 100%;
    }
  }
}
</style>
